
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const LocationFeature = {
  GENERAL_ANALYSIS: 'GENERAL_ANALYSIS',
  STATEMENT_MATCHING: 'STATEMENT_MATCHING',
  END_OF_MONTH_REVIEWS: 'END_OF_MONTH_REVIEWS',
  VENDOR_INVOICES: 'VENDOR_INVOICES'
} as const

export type LocationFeature = (typeof LocationFeature)[keyof typeof LocationFeature]


export const NotificationType = {
  SYSTEM: 'SYSTEM',
  INVOICE_REVIEW: 'INVOICE_REVIEW'
} as const

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType]


export const ThreadType = {
  GENERAL_ANALYSIS: 'GENERAL_ANALYSIS',
  STATEMENT_ANALYSIS: 'STATEMENT_ANALYSIS',
  EOM_REVIEW_ANALYSIS: 'EOM_REVIEW_ANALYSIS',
  VENDOR_INVOICE_ANALYSIS: 'VENDOR_INVOICE_ANALYSIS',
  PURCHASE_JOURNAL_ANALYSIS: 'PURCHASE_JOURNAL_ANALYSIS'
} as const

export type ThreadType = (typeof ThreadType)[keyof typeof ThreadType]


export const FeedbackStatus = {
  NEW: 'NEW',
  UNDER_REVIEW: 'UNDER_REVIEW',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED'
} as const

export type FeedbackStatus = (typeof FeedbackStatus)[keyof typeof FeedbackStatus]


export const ApprovalStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED'
} as const

export type ApprovalStatus = (typeof ApprovalStatus)[keyof typeof ApprovalStatus]


export const CommentType = {
  COMMENT: 'COMMENT',
  QUESTION: 'QUESTION',
  URGENT: 'URGENT',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED'
} as const

export type CommentType = (typeof CommentType)[keyof typeof CommentType]


export const AuthorizationStatus = {
  PENDING: 'PENDING',
  AWAITING_AUTHORIZATION: 'AWAITING_AUTHORIZATION',
  AUTHORIZED: 'AUTHORIZED',
  REJECTED: 'REJECTED'
} as const

export type AuthorizationStatus = (typeof AuthorizationStatus)[keyof typeof AuthorizationStatus]


export const VendorInvoiceStatus = {
  RECEIVED: 'RECEIVED',
  IN_REVIEW: 'IN_REVIEW',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PENDING_AUTHORIZATION: 'PENDING_AUTHORIZATION',
  AUTHORIZED: 'AUTHORIZED',
  POSTED: 'POSTED',
  FAILED: 'FAILED',
  ON_HOLD: 'ON_HOLD',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  DELETED: 'DELETED'
} as const

export type VendorInvoiceStatus = (typeof VendorInvoiceStatus)[keyof typeof VendorInvoiceStatus]


export const VendorInvoiceHistoryType = {
  CREATED: 'CREATED',
  EDITED: 'EDITED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  ASSIGNED: 'ASSIGNED',
  AUTHORIZED: 'AUTHORIZED',
  MOVED: 'MOVED',
  LINKED_TO_INTACCT: 'LINKED_TO_INTACCT',
  UNLINKED_FROM_INTACCT: 'UNLINKED_FROM_INTACCT',
  ACCRUAL_POSTED: 'ACCRUAL_POSTED',
  ACCRUAL_REMOVED: 'ACCRUAL_REMOVED'
} as const

export type VendorInvoiceHistoryType = (typeof VendorInvoiceHistoryType)[keyof typeof VendorInvoiceHistoryType]
